export const breakpoints = {
  mobile: 900,
  smallDesktop: 1280,
} as const;
